import { Component } from '@angular/core';

@Component({
  selector: 'broker-tooltip-svg',
  templateUrl: './tooltip-svg.component.svg'
})
export class TooltipSvgComponent {}
